import api from "../../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY


export const getDataGraficaDeBarrasDia = (setData,anio,semana,setTotalSemana)=>
{
  
    api.post(`${urlApi}/administracion/visitas/graficas?year=${anio}&week=${semana}`).then((res)=>
    {
        let totalSemana = 0;
        res.data.map((item)=>
        {
            totalSemana = totalSemana+ parseInt(item.Total_Visitas,10)
        })
        setData(res.data)
        setTotalSemana(totalSemana)
        console.log("res.data.data",res.data);
    })
    .catch((error)=>
    {
        console.log("error",error);
    })
}

export const getDataTableMayor = (setDataTable,week,year)=>
{
    api.post(`${urlApi}/administracion/visitas/mayor-tiempo?week=${week}&year=${year}`).then((res)=>{
        setDataTable(res.data)
        console.log("res.data",res.data);
    })
    .catch((error)=>
    {
        console.log(error);
    })

}
export const getDataTableMenor = (setDataTable,week,year)=>
{
    api.post(`${urlApi}/administracion/visitas/menor-tiempo?week=${week}&year=${year}`).then((res)=>{
        setDataTable(res.data)
        console.log("res.data",res.data);
    })
    .catch((error)=>
    {
        console.log(error);
    })

}